import { C_Global_Error_Code } from '../../../graphql/generatedModel';
import { IApiError } from '../../../shared/responseHandler/responseHandler';

const EXPECTED_CONNECT_ERROR_CODES: C_Global_Error_Code[] = [
  C_Global_Error_Code.GEC61_BAKERY2B_USER_ALREADY_CONNECTED_TO_THIS_COMPANY,
  C_Global_Error_Code.GEC62_BAKERY2B_USER_IS_DEACTIVATED,
  C_Global_Error_Code.GEC63_BAKERY2B_USER_ALREADY_LINKED_TO_THIS_CUSTOMER,
];

const KNOWN_CONNECT_ERROR_CODES: C_Global_Error_Code[] = [
  ...EXPECTED_CONNECT_ERROR_CODES,
  C_Global_Error_Code.GEC64_BAKERY2B_INVITE_API_ERROR,
];

export const resolveBakery2bConnectError = (
  err: IApiError,
): { reportToSentry: boolean } | undefined => {
  const code = err.code as C_Global_Error_Code;
  if (!KNOWN_CONNECT_ERROR_CODES.includes(code)) {
    return undefined;
  }
  return { reportToSentry: !EXPECTED_CONNECT_ERROR_CODES.includes(code) };
};
